import React from "react";
import styles from "./admin.module.scss";
import cx from "./cx";
import Icon, { IconName } from "./Icon";

type Tone = "ok" | "error" | "info" | "warn";

const tone: Record<Tone, [string, IconName]> = {
  ok: [styles.aOk, "check"],
  error: [styles.aErr, "alert"],
  info: [styles.aInfo, "info"],
  warn: [styles.aWarn, "alert"],
};

interface AlertProps {
  tone?: Tone;
  className?: string;
  children: React.ReactNode;
}

const Alert: React.FC<AlertProps> = ({
  tone: t = "info",
  className,
  children,
}) => (
  <div
    className={cx(styles.alert, tone[t][0], className)}
    role={t === "error" ? "alert" : "status"}
  >
    <Icon name={tone[t][1]} size={18} strokeWidth={2} />
    <span>{children}</span>
  </div>
);

export default Alert;
